// Раскладка нижней панели навигации (NavMenu.vue).
//
// Мест всегда пять — на это же рассчитана вёрстка кнопок. Два крайних заняты всегда:
// «Создать» в середине и «Меню» последней. Остальные три отдаются навигации.
//
// Места фиксированы, а не подстраиваются под число пунктов, именно ради середины:
// если бы кнопок было переменное количество, «Создать» гуляла бы по панели.
export const TAB_SLOTS = 5;

// Индексы с нуля. CREATE_SLOT — ровно середина пяти.
export const CREATE_SLOT = 2;
export const MENU_SLOT = 4;

// Пункты навигации попадают в оставшиеся места по порядку приоритета. Пустое место
// остаётся пустым, а не схлопывается: иначе «Создать» сдвинулась бы с середины.
export const NAV_SLOTS = [0, 1, 3];

export function arrangeTabs(navItems, createTab, menuTab) {
    const slots = new Array(TAB_SLOTS).fill(null);

    NAV_SLOTS.forEach((slot, index) => {
        slots[slot] = navItems[index] || null;
    });

    slots[CREATE_SLOT] = createTab;
    slots[MENU_SLOT] = menuTab;

    return slots;
}

// Пункты, которым места не хватило: они доступны через «Меню», и их непрочитанное
// собирается на её бейдже.
export function restNavItems(navItems) {
    return navItems.slice(NAV_SLOTS.length);
}

export function countUnread(items) {
    return items.reduce((sum, item) => sum + (item.counter || 0), 0);
}
